import { useState, useEffect, useCallback } from 'react';
import { Plus, Trash2, Loader2, Briefcase } from 'lucide-react';
import { AdminLayout } from '../components/AdminLayout';
import adminApi from '../lib/adminApi';

export default function AdminTiposEmpresa() {
  const [tipos, setTipos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [novoNome, setNovoNome] = useState('');
  const [salvando, setSalvando] = useState(false);
  const [erro, setErro] = useState('');

  const carregar = useCallback(async () => {
    setLoading(true);
    try {
      const res = await adminApi.get('/admin/tipos-empresa');
      setTipos(res.data);
    } finally { setLoading(false); }
  }, []);

  useEffect(() => { carregar(); }, [carregar]);

  const handleCriar = async (e) => {
    e.preventDefault();
    if (!novoNome.trim()) return;
    setSalvando(true); setErro('');
    try {
      await adminApi.post('/admin/tipos-empresa', { nome: novoNome.trim() });
      setNovoNome('');
      carregar();
    } catch (err) {
      setErro(err?.response?.data?.detail || 'Erro ao criar tipo de empresa');
    } finally { setSalvando(false); }
  };

  const handleExcluir = async (t) => {
    if (!window.confirm(`Excluir "${t.nome}"?`)) return;
    try {
      await adminApi.delete(`/admin/tipos-empresa/${t.id}`);
      carregar();
    } catch (err) {
      alert(err?.response?.data?.detail || 'Erro ao excluir');
    }
  };

  return (
    <AdminLayout title="Tipos de Empresa">
      <form onSubmit={handleCriar} className="bg-white rounded-2xl border border-gray-100 p-5 mb-5 flex gap-3">
        <input
          value={novoNome}
          onChange={e => setNovoNome(e.target.value)}
          placeholder="Novo tipo (ex: Material de Construção)"
          data-testid="tipo-empresa-nome-input"
          className="flex-1 border border-gray-200 rounded-xl px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#1D9E75]"
        />
        <button
          type="submit"
          disabled={salvando || !novoNome.trim()}
          data-testid="criar-tipo-empresa-btn"
          className="flex items-center gap-2 bg-[#1D9E75] hover:bg-[#178460] text-white font-medium rounded-xl px-4 py-2 text-sm transition-colors disabled:opacity-50"
        >
          {salvando ? <Loader2 size={14} className="animate-spin" /> : <Plus size={14} />}
          Adicionar
        </button>
      </form>

      {erro && <p className="text-red-600 text-sm mb-3">{erro}</p>}

      <p className="text-xs text-gray-400 mb-3">{tipos.length} tipos cadastrados</p>

      {loading ? (
        <div className="py-12 text-center text-gray-400 flex items-center justify-center gap-2">
          <Loader2 size={16} className="animate-spin" /> Carregando...
        </div>
      ) : tipos.length === 0 ? (
        <div className="bg-white rounded-2xl border border-dashed border-gray-200 p-10 text-center">
          <Briefcase size={28} className="text-gray-300 mx-auto mb-2" />
          <p className="text-sm text-gray-500">Nenhum tipo de empresa cadastrado.</p>
        </div>
      ) : (
        <div className="bg-white rounded-2xl border border-gray-100 divide-y divide-gray-100 overflow-hidden">
          {tipos.map((t) => (
            <div key={t.id} data-testid="tipo-empresa-row" className="flex items-center gap-3 px-4 py-3 hover:bg-gray-50">
              <div className="w-8 h-8 rounded-lg bg-[#E1F5EE] flex items-center justify-center flex-shrink-0">
                <Briefcase size={13} className="text-[#1D9E75]" />
              </div>
              <p className="flex-1 text-sm text-gray-900">{t.nome}</p>
              <button
                onClick={() => handleExcluir(t)}
                data-testid="excluir-tipo-empresa-btn"
                className="p-1.5 hover:bg-red-50 rounded-lg text-gray-400 hover:text-red-600 transition-colors"
              >
                <Trash2 size={14} />
              </button>
            </div>
          ))}
        </div>
      )}
    </AdminLayout>
  );
}
